import { RouteConfig } from 'vue-router';
import combineGuards from '@/router/guards/helpers';
import { requireAuthenticated } from '@/router/guards/authGuards';
import { checkPremiumParentRegistration, checkSitterOnboarding } from '@/router/guards/completionGuards';
import MessagesApp from '@/apps/messages/MessagesApp.vue';

const messagingAccessGuards = combineGuards([requireAuthenticated, checkPremiumParentRegistration, checkSitterOnboarding]);

const messagesRoutes: RouteConfig[] = [
  {
    path: '/messages',
    name: 'Messages',
    component: MessagesApp,
    beforeEnter: messagingAccessGuards,
  },
];

export default messagesRoutes;
